import apVideoAv1 from '@webapp/platform/discover-more/assets/videos/ap-promo-av1-primary.mp4'
import apVideoH264 from '@webapp/platform/discover-more/assets/videos/ap-promo-h264-fallback.mp4'
import apVideoPoster from '@webapp/platform/discover-more/assets/videos/ap-promo-poster.jpg'
import { type IHeroVideo } from '@webapp/platform/discover-more/components/FeatureShowcase'

/** Shared by the Discover more AP tab and the AP left-nav promo page */
export const AP_HERO_VIDEO: IHeroVideo = {
  poster: apVideoPoster,
  sources: [
    {
      src: apVideoAv1,
      type: 'video/mp4; codecs="av01.0.08M.08.0.111.01.13.01.0"',
    },
    {
      src: apVideoH264,
      type: 'video/mp4; codecs="avc1.640033"',
    },
  ],
  isExpandable: true,
}
